import angular from 'angular';
import Model from './model';

function FactList(Model, $q) {
	return class FactListModel extends Model {
		constructor(data = {}) {
			super(data);
			this.setApi("/case/:caseId/facts", {
				caseId: '@caseId',
				queryId: '@queryId',
				skip: '@skip',
				limit: '@limit',
			}, {
				get: {
					method: 'GET'
				},
				getMore: {
					method: 'GET',
					success: [data => {
						this.setMore(data);
					}]
				},
				getFactsByCreationDate: {
					method: 'GET',
					url: '/case/:caseId/factsByCreationDate'
				},
				getMoreByCreationDate: {
					method: 'GET',
					url: '/case/:caseId/factsByCreationDate',
					success: [data => {
						this.setMore(data);
					}]
				},
			});
		}
		setMore(data) {
			this.data.lastResult = data.lastResult;
			this.data.limit = data.limit;
			this.data.skip = data.skip;
			this.data.rows = this.data.rows.concat(data.rows);
			this.setData();
		}
		loadMore() {
			if (this.data.lastResult) {
				var q = $q.defer();
				q.resolve();
				return q.promise;
			} else {
				this.data.skip = this.data.skip + this.data.limit;
				return this.api.getMore();
			}
		}
		loadMoreByCreationDate() {
			if (this.data.lastResult) {
				var q = $q.defer();
				q.resolve();
				return q.promise;
			} else {
				this.data.skip = this.data.skip + this.data.limit;
				return this.api.getMoreByCreationDate();
			}
		}
		reload(index = 0) {
			this.data.limit = index + 20;
			this.data.skip = 0;
			return this.api.get();
		}
		setFact(fact) {
			var factRows = this.data.rows.filter(row => row.row && row.row.id === fact.id)
			if (factRows && factRows.length !== 0) {
				factRows.forEach(row => row.row = fact);
			} else {
				this.data.rows.unshift({
					row: fact
				});
			}
			this.setData();
		}
		removeFact(fact) {
			this.data.rows = this.data.rows.filter(row => row.row ? row.row.id !== fact.id : true);
		}
	}
}
FactList.$inject = ['Model', '$q'];

export default angular.module('models.fact-list', [Model])
	.factory('FactListFactory', FactList)
	.service('FactList', ['FactListFactory', FactListFactory => new FactListFactory()])
	.name;



// WEBPACK FOOTER //
// ./project/models/fact-list.js